export default "__VITE_ASSET__c8602ad6__"